import { Injectable, Injector } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LegacyRedirectModalComponent } from './ui/modal/legacy-redirect-modal/legacy-redirect-modal.component';

/**
 * Tells users that Fair Supply has moved to the new platform. Shown once per browser session, the first time the user
 * lands on the app.
 */
@Injectable({
  providedIn: 'root',
})
export class LegacyRedirectService {
  private readonly seenKey = 'seenLegacyRedirect';

  constructor(private injector: Injector) {}

  private get modalService(): BsModalService {
    return this.injector.get(BsModalService);
  }

  showOnce() {
    if (sessionStorage.getItem(this.seenKey)) {
      return;
    }
    this.modalService.show(LegacyRedirectModalComponent, {
      class: 'modal-dialog-centered legacy-redirect-dialog',
      ignoreBackdropClick: true,
      ariaLabelledBy: 'legacyRedirectLabel',
    });
    sessionStorage.setItem(this.seenKey, 'true');
  }
}
